import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LogisticaService } from '../services/logistica.service';
import { showSpinner, hideSpinner } from 'src/app/core/services/functions.service';
import { ModalHistoricoMovimientosComponent } from '../modal-historico-movimientos/modal-historico-movimientos.component';
import Swal from 'sweetalert2';

interface Poligono {
  ID_POLI: number;
  COD_POLIGONO: string;
  NOMBRE_POLIGONO: string;
  ESTADO_LEGIBLE: string;
}

@Component({
  selector: 'app-historial-apertura-cierre',
  templateUrl: './historial-apertura-cierre.component.html',
  styleUrls: ['./historial-apertura-cierre.component.scss']
})
export class HistorialAperturaCierreComponent implements OnInit {
  filtroPoligono: FormControl = new FormControl();
  poligonosFiltrados: Observable<Poligono[]>;
  poligonos: Poligono[] = [];
  historial: any[] = [];
  filtroFecha: string = '';
  selectedPoligonoId: number | null = null;
  loading = false;
  loadingHistorial = false;

  constructor(
    private logisticaService: LogisticaService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.cargarPoligonos();
  }

  async cargarPoligonos() {
    this.loading = true;
    showSpinner();
    try {
      const response = await this.logisticaService.obtenerPoligonos();
      if (response.success) {
        this.poligonos = response.data;
        
        // Configurar el filtro de polígonos
        this.poligonosFiltrados = this.filtroPoligono.valueChanges.pipe(
          startWith(''),
          map(value => this._filtrarPoligonos(value || ''))
        );
      } else {
        Swal.fire('Error', 'No se pudieron cargar los polígonos', 'error');
      }
    } catch (error) {
      Swal.fire('Error', 'Error al cargar los polígonos', 'error');
    } finally {
      this.loading = false;
      hideSpinner();
    }
  }

  private _filtrarPoligonos(value: string): Poligono[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
    return this.poligonos.filter(poligono =>
      poligono.NOMBRE_POLIGONO.toLowerCase().includes(filterValue) ||
      poligono.COD_POLIGONO.toLowerCase().includes(filterValue)
    );
  }

  onPoligonoSelected(event: any): void {
    const selectedPoligono = event.option.value;
    this.selectedPoligonoId = selectedPoligono.ID_POLI;
    this.onPoligonoChange();
  }

  displayPoligono(poligono?: Poligono): string {
    return poligono ? `${poligono.COD_POLIGONO} - ${poligono.NOMBRE_POLIGONO} (${poligono.ESTADO_LEGIBLE})` : '';
  }

  async onPoligonoChange() {
    this.filtroFecha = '';
    if (!this.selectedPoligonoId) {
      this.historial = [];
      return;
    }

    this.loadingHistorial = true;
    try {
      const response = await this.logisticaService.obtenerHistorialPoligono(this.selectedPoligonoId);
      if (response.success) {
        this.historial = response.data;
        if (this.historial.length === 0) {
          Swal.fire('Información', 'No hay historial disponible para este polígono', 'info');
        }
      } else {
        Swal.fire('Error', 'No se pudo cargar el historial', 'error');
      }
    } catch (error) {
      Swal.fire('Error', 'Error al cargar el historial', 'error');
    } finally {
      this.loadingHistorial = false;
    }
  }

  verMovimientos(): void {
    if (!this.selectedPoligonoId) return;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { idPoligono: this.selectedPoligonoId };
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '1100px';

    this.dialog.open(ModalHistoricoMovimientosComponent, dialogConfig);
  }

  getEstadoLabel(estado: string): string {
    return estado === 'C' ? 'Cerrado' : estado === 'A' ? 'Abierto' : estado;
  }

  formatDate(date: string): string {
    if (!date) return '-';
    return new Date(date).toLocaleString('es-CO');
  }

  formatDateOnly(date: string): string {
    if (!date) return '-';
    const part = String(date).substring(0, 10);
    const [y, m, d] = part.split('-').map(Number);
    return new Date(y, m - 1, d).toLocaleDateString('es-CO');
  }

  formatNumber(num: number): string {
    return num ? num.toFixed(2) : '0.00';
  }
}
